<template>
  <IonPage>
    <master-layout @refreshPage="reRender" page-title="دریافتی ها">
      <Loading :is="!docLoaded" v-if="!docLoaded"></Loading>
      <div v-if="docLoaded && doc">
        <AjaxForm :route="'incoming/Edit/'+doc._id">
            <ion-card-content>
              <div class="text-success doc-status space-between">
                <div> وضعیت :
                  <span v-if="doc.status">تایید شده</span>
                  <span v-else>ثبت شده</span>
                </div>
                <div>ش سند : {{ doc.order_number }}</div>
              </div>

              <div v-if="customer" class="space-between pt-2 pb-2">
                <div>
                  <div class="mb-1"><i class="far fa-user icon"></i> {{ customer.fullname }}</div>
                  <div class="mb-1"><i class="far fa-phone icon"></i> {{ customer.phone }}</div>
                  <div><i class="far fa-wallet icon"></i>
                    <Money :number="customer.balance"></Money>
                  </div>
                </div>
                <div>
                  <button class="btn btn-info" type="button" v-if="doc" @click="addItemToList()">افزودن آیتم</button>
                </div>
              </div>
              <div class="space-between ">
                <div>تعداد اسناد: {{ items.length }}</div>
                <div>مبلغ کل:
                  <Money :number="total_price"></Money>
                </div>
              </div>

            </ion-card-content>
            <IonCard v-for="(item,index) in items" :key="item.id">
              <IonCardContent>
                <i @click="removeItemFromList(index)" class="far fa-trash-alt remove"></i>
                <i @click="addItemToList()" class="far fa-plus add"></i>
                <div class="form-group">
                  <input hidden="" readonly name="id[]" :value="item.id" type="hidden">
                  <label>نوع سند</label>
                  <select v-model="item.doc_type_id" class="form-control" name="doc_type_id[]">
                    <option v-for="(d,index) in doc_types" :key="index" :value="d._id">{{ d.title }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>تاریخ سند</label>
                  <date-input v-model="item.input_date" class="w-100" name="due_date[]"></date-input>
                </div>
                <div class="form-group">
                  <label>مبلغ</label>

                  <NumberInput name="price[]" @input="(e)=>{item.total=e}" v-model="item.total" :value="item.total"
                               placeholder="مبلغ سند"/>
                </div>
                <div class="form-group">
                  <label>شماره</label>
                  <input type="tel" :value="item.number" class="form-control" placeholder="شماره سند"
                         name="number[]">
                </div>
                <div class="form-group">
                  <input type="tel" :value="item.content" class="form-control" placeholder="شرح سند"
                         name="content[]">
                </div>
                <div v-if="item.file_url" class="form-group">
                 <a :href="item.file_url" target="_blank"> مشاهده فایل آپلود شده <i class="fa fa-file"></i></a>
                  <input type="hidden" readonly tabindex="-100" class="d-none" :name="'old_file_'+item.id" :value="item.file_name">
                </div>
                <div class="form-group">
                  <label>فایل مربوط به سند</label>
                  <input class="form-control" type="file"  accept="image/*" :name="'file_'+item.id">
                </div>
              </IonCardContent>
            </IonCard>
          <button class="d-none" id="submit_btn" type="submit"></button>
        </AjaxForm>
        <div class="gap_div"></div>
      </div>
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>

    </master-layout>
    <button v-if="items.length" @click="submitBtnClick" class="btn btn-success btn-block mt-0 submit_btn" type="submit">ویرایش سند</button>
  </IonPage>
</template>

<script>
import AjaxForm from "@/components/AjaxForm";
import AliAjaxSelect from "@/components/aliAjaxSelect";
import Money from "@/components/Money";
import {mapActions} from "vuex";
import {IonCardContent, IonCol, IonRow,IonCard,IonPage} from "@ionic/vue";
import Loading from "../../components/Loading";
import NumberInput from "../../components/NumberInput";
import {compressImage, makeCode} from "@/shared/helper";
import DateInput from "@/components/DateInput.vue";



export default {
  name: "list",
  components: {
    DateInput, AjaxForm,AliAjaxSelect,IonCard,NumberInput,IonPage,
    Money,IonCardContent,IonRow,IonCol,Loading},
  data(){
    return {
      items: [],
      total_price: 0,
      customer_id: null,
      doc: null,
      docLoaded : false,
      error : false,
      customer : null,
      doc_types : [],
    }
  },
  async mounted()
  {
    const check = await this.getDocTypes();
    if (check && check.ok)
      this.doc_types = check.doc_types;
    await this.init();
  },
  methods: {
    async handelImageInput (event,id)
    {
      const files = await compressImage(event);
      console.log('files is :',files)
      document.querySelector('#input_'+id).files = files
    },
    submitBtnClick()
    {
      document.getElementById('submit_btn').click();
    },
    async init()
    {
      this.docLoaded = false;
      this.id = this.$route.params.id;
      const result = await this.getIncomingDoc(this.id);
      if (result)
      {
        if (result.ok)
        {
          this.docLoaded = true;
          this.doc = result.doc;
          this.items = result.doc_items;
          this.customer = result.customer;
          this.total_price = this.doc.total;
        }
        else
        {
          this.docLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.customerLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    ...mapActions('incoming',{
      getIncomingDoc : 'getIncomingDoc',
      getDocTypes : 'getDocTypes'
    }),
    addItemToList()
    {
      this.items.push({price : 0,id : makeCode(5)});
    },
    removeItemFromList(index)
    {
      this.items.splice(index,1);
      this.calculateSumPrice();
    },
    calculateSumPrice()
    {
      this.total_price = 0;
      for(let i = 0; i < this.items.length; i++)
      {
        if (this.items[i].total && !isNaN(this.items[i].total))
          this.total_price += parseInt(this.items[i].total);
      }
    },
    changeCustomer: async function (items)
    {
      if (items && items.length)
      {
        this.doc = items[0]
      }
      const result = await this.getCustomerProduct(this.doc._id);
      if (result.ok)
      {
        this.products = result.products;
        for (let i = 0; i < this.products.length; i++)
        {
          this.products[i].total = 0;
          this.products[i].selected_qty = '';
        }
      }
    },
    changeItemsEvent()
    {
      for (let i = 0; i < this.items.length; i++)
      {
        this.items[i].change = Math.random()*10000;
      }
    },
    changeDate(date,index)
    {
      this.items[index].input_date = date;
    },
    reRender()
    {
      this.init();
    }
  },
  watch:{
    items : {
      handler()
      {
        this.calculateSumPrice();
      },deep: true,
    }
  }
}
</script>

<style scoped>
.submit_btn
{
  position: fixed;
  bottom: 0!important;
  margin-bottom: 58px;
}
.d-none
{
  display: none;
}
.gap_div
{
  height: 37px;
  background: transparent;
}

.doc-item-box {
  border: 1px dashed #000;
  padding: 25px 15px 10px 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  background-color: #f8f8f8;
  position: relative;
}
.remove{
  left: 0;
  position: absolute;
  color: #e84848;
  font-size: 20px;
  padding: 5px;
  top: -5px;
}
.add {
  left: 45px;
  position: absolute;
  color: #08bf8d;
  font-size: 20px;
  padding: 5px;
  top: -5px;
}
.form-group
{
  display: flex;
  justify-content: space-between;
}
.form-group label
{
  width: 95px;
}
.doc-status
{
  font-size: 14px;
  text-align: center;
  font-weight: 900;
}
.space-between {
  display: flex;
  justify-content: space-between;
}
.pt-2
{
  padding-top: 7px;
}
.pb-2
{
  padding-bottom: 7px;
}
.mb-1
{
  margin-bottom: 4px;
}
.mt-0
{
  margin-top: 0!important;
}
.page-div {
  height: calc(100vh - 146px);
  overflow-y: auto;
}
.icon
{
  width: 25px;
  text-align: center;
}
</style>